import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { suppliesItemListRequest } from '../../../redux/supplies/supplies.action'
import { isEmpty, isNull } from "../../../utils/Utils";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { ROUTES } from "../../../utils/AppConstants";

const SuppliesItemList = props => {
    const { user } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { state } = useLocation()
    const { suppliesItemListSuccess, suppliesItemListError } = useSelector(state => state.supplies)

    useEffect(() => {
        fetchItemList()
    }, [])

    useEffect(() => {
        if (!isEmpty(suppliesItemListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(suppliesItemListError)) {
            setLoading(false)
        }
    }, [suppliesItemListSuccess, suppliesItemListError])

    const isPermissionAllowed = () => {
        return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.ADD_ITEM, parseFloat(state.businessId), parseFloat(state.locationId))
    }

    const fetchItemList = () => {
        setLoading(true)
        const data = {
            businessId: state.businessId,
            locationId: state.locationId,
            suppliesCategoryId: state.suppliesCategoryId
        }
        dispatch(suppliesItemListRequest(data))
    }

    const handleAddItemClick = () => {
        navigate(ROUTES.supplies.item.newItem, {
            state: {
                suppliesCategoryId: state.suppliesCategoryId,
                categoryName: state.categoryName,
                businessId: state.businessId,
                locationId: state.locationId
            }
        })
    }

    const handleDetailClick = (item) => {
        navigate(ROUTES.supplies.item.detail, {
            state: {
                suppliesId: item.suppliesId,
                businessId: state.businessId,
                locationId: state.locationId
            }
        })
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Supplies' />
                {!isNull(suppliesItemListSuccess) && !isEmpty(suppliesItemListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">SKU</th>
                                <th scope="col" className="text-center">Stock</th>
                                <th scope="col" className="text-center">Reorder Threshold</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {suppliesItemListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">{element.sku}</td>
                                    <td className="text-center">{element.stock}</td>
                                    <td className="text-center">{element.reorderThreshold}</td>
                                    <td className="text-center">
                                        <div className={element.isActive === true ? 'active' : 'in-active'}>{element.isActive === true ? 'Active' : 'In-Active'}</div>
                                    </td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleDetailClick(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(suppliesItemListError) && <div className="content-error">{suppliesItemListError.message}</div>}
                {isPermissionAllowed() && <div className="vl-fab-container" onClick={() => handleAddItemClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default SuppliesItemList